import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute } from '../route';
import paths from '../../../paths';

const searchSchema = z.object({
  policyId: z.string().uuid().optional(),
});

export const Route = createRoute({
  path: paths.authenticated.guardrailPolicies,
  getParentRoute: () => pathlessAuthenticatedRoute,
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    const target = '/settings/organization/guardrail-policies' as const;
    throw redirect(
      search.policyId
        ? { to: target, search: { policyId: search.policyId } as never }
        : { to: target },
    );
  },
});
